import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import compose from '../../hoc/compose';
import textLabelBase from '../textLabel/textLabelBase';
import displayNames from '../displayNames';
var Bubble = /*#__PURE__*/function (_React$Component) {
  function Bubble(props) {
    var _this;
    _classCallCheck(this, Bubble);
    _this = _callSuper(this, Bubble, [props]);
    _this.getContentRef = function (ref) {
      _this.content = ref;
    };
    _this.getContentStyle = function () {
      return _this.props.maxWidth ? _.assign({
        maxWidth: _this.props.maxWidth
      }, _this.props.contentStyle) : _this.props.contentStyle;
    };
    _this.getChildren = function () {
      if (_.isString(_this.props.children)) {
        return /*#__PURE__*/React.createElement(textLabelBase, {
          shouldTranslate: props.shouldTranslate,
          value: _this.props.children
        });
      }
      if (Array.isArray(_this.props.children)) {
        return _this.props.children.map(function (c) {
          if (_.isString(c)) {
            return /*#__PURE__*/React.createElement(textLabelBase, {
              shouldTranslate: props.shouldTranslate,
              value: c
            });
          }
          return c;
        });
      }
      return _this.props.children;
    };
    return _this;
  }
  _inherits(Bubble, _React$Component);
  return _createClass(Bubble, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (_.isFunction(this.props.onLayoutChange)) {
        this.props.onLayoutChange(this.content);
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var didTargetContentChanged = !_.isEqual(this.props.targetContent, prevProps.targetContent);
      var shouldReLayout = didTargetContentChanged || !_.isEqual(this.props.contentStyle, prevProps.contentStyle);
      if (_.isFunction(this.props.onLayoutChange) && shouldReLayout) {
        this.props.onLayoutChange(this.content);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement("span", {
        className: this.props.getClassName("bubble".concat(this.props.isHint ? ' hint' : '', " arrow-").concat(this.props.arrowAlignment)),
        onMouseEnter: this.props.onMouseEnter,
        onMouseLeave: this.props.onMouseLeave,
        onClick: this.props.onClick,
        "data-hook": this.props.dataHook
      }, /*#__PURE__*/React.createElement("div", {
        className: "bubble-content",
        ref: this.getContentRef,
        style: this.getContentStyle(),
        key: "content"
      }, this.getChildren()), this.props.arrowStyle ? /*#__PURE__*/React.createElement("div", {
        className: "bubble-arrow",
        key: "arrow",
        style: this.props.arrowStyle
      }) : null);
    }
  }]);
}(React.Component);
Bubble.displayName = displayNames.BUBBLE;
Bubble.propTypes = {
  /** Specifies a CSS class name to be appended to the component’s root element */
  className: PropTypes.string,
  /** Applies a data-hook HTML attribute that can be used in the tests */
  dataHook: PropTypes.string,
  /** onLayoutChange */
  onLayoutChange: PropTypes.func,
  /** onMouseEnter */
  onMouseEnter: PropTypes.func,
  /** onMouseLeave */
  onMouseLeave: PropTypes.func,
  /** onClick */
  onClick: PropTypes.func,
  /** arrowAlignment */
  arrowAlignment: PropTypes.oneOf(['top', 'right', 'bottom', 'left']),
  /** arrowStyle */
  arrowStyle: PropTypes.object,
  /** contentStyle */
  contentStyle: PropTypes.object,
  /** targetContent */
  targetContent: PropTypes.object,
  /** maxWidth */
  maxWidth: PropTypes.number,
  /** isHint */
  isHint: PropTypes.bool
};
Bubble.defaultProps = {
  maxWidth: 240
};
export default compose(Bubble);